import {
  Box,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tooltip,
} from "@mui/material";
import { Icons, Images } from "assets";
import classNames from "classnames";
import { useState } from "react";
import useWindowSize from "shared/customHooks/windowSize";
import styles from "./style.module.scss";
import { routeConstant } from "shared/routes/routesConstant";
import { useNavigate } from "react-router-dom";

function PartnersDetailGrid() {
  const navigate = useNavigate();
  const screenWidth = useWindowSize();
  const [activeTab, setActiveTab] = useState<any>(0);

  let partnersDetail = [
    {
      name: "Jake Paul",
      email: "jakepaul@yopmail.com",
      status: 1,
      phone: "030100201211",
    },
    {
      name: "Emma Stone",
      email: "emmastone@yopmail.com",
      status: 0,
      phone: "030100322312",
    },
    {
      name: "Kate Wilson",
      email: "katewilson@yopmail.com",
      status: 1,
      phone: "030100322212",
    },
  ];

  const tabs = [
    {
      value: 0,
      label: "Publishers Accounts",
    },
    {
      value: 1,
      label: "Authors Accounts",
    },
  ];

  const tabs_enums = {
    publishers: 0,
    authors: 1,
  };

  const handleChange = (event: any, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainTableContainer}>
        <Box className={styles.topHeadingContainer}>
          <div>
            <div className={styles.heading}>Partners Accounts</div>
            <div className={styles.subHeading}>
              Manage your Approved partner's accounts here.
            </div>
          </div>
          <div className={styles.btnContainer}>
            <button
              className={styles.viewAllBtn}
              onClick={() => navigate(routeConstant.partnerListings.path)}
            >
              View All
            </button>
            <button className={styles.filterBtn}>
              <Icons.FilterIcon /> Filter
            </button>
          </div>
        </Box>

        <Box className={styles.boxContainer}>
          <Tabs
            value={activeTab}
            onChange={handleChange}
            className={styles.tab}
            TabIndicatorProps={{
              style: {
                backgroundColor: "black",
              },
            }}
            sx={{ background: "white", padding: "0px 14px" }}
          >
            {tabs?.map((item: any, index: any) => {
              return (
                <Tab
                  label={
                    <div
                      className={classNames(
                        styles.tabs,
                        activeTab === item?.value && styles.active
                      )}
                    >
                      <label className={styles.tabLabel}> {item?.label}</label>
                    </div>
                  }
                  sx={{ padding: "0px" }}
                />
              );
            })}
          </Tabs>
        </Box>

        <TableContainer
          component={Paper}
          sx={screenWidth > 990 ? { width: `${screenWidth - 300}px` } : {}}
          className={styles.tableContainer}
          id="table-view-dashboard"
        >
          <Table>
            <TableHead className={styles.tableHead}>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Earnings</TableCell>
                <TableCell>MOU</TableCell>
                <TableCell>Books Published</TableCell>
                <TableCell>Linked Accounts</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody}>
              {partnersDetail?.map((item: any, index: number, arr: any[]) => {
                return (
                  <TableRow
                    className={classNames(
                      index + 1 === arr?.length && styles.noBorder
                    )}
                  >
                    <TableCell
                      sx={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={Images.UserPlaceholderImage}
                          alt="profile_picture"
                          className={styles.profilepic}
                        />
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label>{item?.name}</label>
                          <label className={styles.publishingHouse}>
                            Publishing House
                          </label>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>Rs 40,000</TableCell>
                    <TableCell>Signed</TableCell>
                    <TableCell>320</TableCell>
                    <TableCell>04</TableCell>
                    <TableCell>
                      <div className={styles.actionContainer}>
                        <Tooltip
                          componentsProps={{
                            tooltip: { className: "tooltip" },
                            arrow: { className: "arrow" },
                          }}
                          placement="top"
                          arrow
                          title="View"
                        >
                          <div
                            onClick={() => {
                              if (activeTab === tabs_enums.publishers) {
                                navigate(
                                  routeConstant.partnerProfile.path
                                    .replace(":role", "publisher")
                                    .replace(":id", "1")
                                );
                              } else {
                                navigate(
                                  routeConstant.partnerProfile.path
                                    .replace(":role", "author")
                                    .replace(":id", "1")
                                );
                              }
                            }}
                          >
                            <Icons.EyeIcon />
                          </div>
                        </Tooltip>
                        <Tooltip
                          componentsProps={{
                            tooltip: { className: "tooltip" },
                            arrow: { className: "arrow" },
                          }}
                          placement="top"
                          arrow
                          title="MOU"
                        >
                          <div>
                            <Icons.PartnersIcon
                              style={{ width: "18px", height: "18px" }}
                            />
                          </div>
                        </Tooltip>
                        <Tooltip
                          componentsProps={{
                            tooltip: { className: "tooltip" },
                            arrow: { className: "arrow" },
                          }}
                          placement="top"
                          arrow
                          title="Support Chat"
                        >
                          <div>
                            <Icons.MsgActionIcon
                              style={{ width: "18px", height: "18px" }}
                            />
                          </div>
                        </Tooltip>

                        <Tooltip
                          componentsProps={{
                            tooltip: { className: "tooltip" },
                            arrow: { className: "arrow" },
                          }}
                          placement="top"
                          arrow
                          title={item?.status ? "Deactivate" : "Activate"}
                        >
                          <div>
                            {item?.status ? (
                              <Icons.UserDeactivate
                                className={classNames(
                                  styles.icons,
                                  styles.deactive
                                )}
                              />
                            ) : (
                              <Icons.UserActivate
                                className={classNames(
                                  styles.icons,
                                  styles.active
                                )}
                              />
                            )}
                          </div>
                        </Tooltip>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default PartnersDetailGrid;
